import { MenuItem } from '../models/menu-item';

export const MENUITEMS: MenuItem[] =
    [
        {
            id: 2,
            routerLink: 'project',
            nameEN: 'Who we are',
            nameIT: 'Chi siamo',
            guard: false
        },
        {
            id: 3,
            routerLink: 'where',
            nameEN: 'Where',
            nameIT: 'Dove',
            guard: false
        }/*,
        {
            id: 4,
            routerLink: 'contacts',
            nameEN: 'Register',
            nameIT: 'Registrati',
            guard: false
        },
        {
            id: 5,
            routerLink: 'privacy',
            nameEN: 'Privacy',
            nameIT: 'Privacy',
            guard: false
        },*/

    ];
